import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faTimes } from "@fortawesome/free-solid-svg-icons";
import { trackPromise } from "react-promise-tracker";
import { apiSendRemainder } from "../../../utils/queries";
import { reminderReceiver } from "../../../utils/common";
import "../shared/BrandModal.css";

export const ReminderModal = ({ toggle, setToggle, request, onSent, onError }) => {
  const close = () => setToggle(false);
  const receiver = reminderReceiver(request?.status);

  const handleConfirm = async () => {
    try {
      const result = await trackPromise(apiSendRemainder(request.id));
      close();
      onSent(result.data);
    } catch (err) {
      close();
      onError?.(err);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Send Reminder</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          {receiver ? (
            <>
              Send a reminder email to the <strong>{receiver}</strong> for this request.
            </>
          ) : (
            "Send a reminder email to the relevant party for this request."
          )}
        </p>

        <div className="brand-modal__actions">
          <button type="button" className="brand-modal__btn brand-modal__btn--primary" onClick={handleConfirm}>
            <FontAwesomeIcon icon={faBell} /> Send Reminder
          </button>
          <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
